const anprint = [
    {
        "id": "CAMO",
        "name": "Camo TShirt",
        "sku": "CAMO",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Camo Begie",
                    "Camo Black",
                    "Camo Green",
                    "Camo Yellow"
                ]
            }
        ],
        "variants": [
            {
                "sku": "CM-CAMO-CBE-2XL",
                "name": "Camo - Camo - 2XL - Camo Begie",
                "size": "2XL",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-3XL",
                "name": "Camo - Camo - 3XL - Camo Begie",
                "size": "3XL",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-4XL",
                "name": "Camo - Camo - 4XL - Camo Begie",
                "size": "4XL",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-5XL",
                "name": "Camo - Camo - 5XL - Camo Begie",
                "size": "5XL",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-L",
                "name": "Camo - Camo - L - Camo Begie",
                "size": "L",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-M",
                "name": "Camo - Camo - M - Camo Begie",
                "size": "M",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-S",
                "name": "Camo - Camo - S - Camo Begie",
                "size": "S",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBE-XL",
                "name": "Camo - Camo - XL - Camo Begie",
                "size": "XL",
                "color": "Camo Begie",
                "color_code": "CBE",
                "color_hex": "#d5c4b9",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-2XL",
                "name": "Camo - Camo - 2XL - Camo Black",
                "size": "2XL",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-3XL",
                "name": "Camo - Camo - 3XL - Camo Black",
                "size": "3XL",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-4XL",
                "name": "Camo - Camo - 4XL - Camo Black",
                "size": "4XL",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-5XL",
                "name": "Camo - Camo - 5XL - Camo Black",
                "size": "5XL",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-L",
                "name": "Camo - Camo - L - Camo Black",
                "size": "L",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-M",
                "name": "Camo - Camo - M - Camo Black",
                "size": "M",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-S",
                "name": "Camo - Camo - S - Camo Black",
                "size": "S",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CBK-XL",
                "name": "Camo - Camo - XL - Camo Black",
                "size": "XL",
                "color": "Camo Black",
                "color_code": "CBK",
                "color_hex": "#000000",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-2XL",
                "name": "Camo - Camo - 2XL - Camo Green",
                "size": "2XL",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-3XL",
                "name": "Camo - Camo - 3XL - Camo Green",
                "size": "3XL",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-4XL",
                "name": "Camo - Camo - 4XL - Camo Green",
                "size": "4XL",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-5XL",
                "name": "Camo - Camo - 5XL - Camo Green",
                "size": "5XL",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-L",
                "name": "Camo - Camo - L - Camo Green",
                "size": "L",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-M",
                "name": "Camo - Camo - M - Camo Green",
                "size": "M",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-S",
                "name": "Camo - Camo - S - Camo Green",
                "size": "S",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CGN-XL",
                "name": "Camo - Camo - XL - Camo Green",
                "size": "XL",
                "color": "Camo Green",
                "color_code": "CGN",
                "color_hex": "#257a00",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-2XL",
                "name": "Camo - Camo - 2XL - Camo Yellow",
                "size": "2XL",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-3XL",
                "name": "Camo - Camo - 3XL - Camo Yellow",
                "size": "3XL",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-4XL",
                "name": "Camo - Camo - 4XL - Camo Yellow",
                "size": "4XL",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-5XL",
                "name": "Camo - Camo - 5XL - Camo Yellow",
                "size": "5XL",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-L",
                "name": "Camo - Camo - L - Camo Yellow",
                "size": "L",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-M",
                "name": "Camo - Camo - M - Camo Yellow",
                "size": "M",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-S",
                "name": "Camo - Camo - S - Camo Yellow",
                "size": "S",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "CM-CAMO-CYL-XL",
                "name": "Camo - Camo - XL - Camo Yellow",
                "size": "XL",
                "color": "Camo Yellow",
                "color_code": "CYL",
                "color_hex": "#ffc800",
                "style": "CM",
                "style_name": "Camo TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "18500",
        "name": "Hoodie",
        "sku": "18500",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "3XL",
                    "4XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Dark Heather",
                    "Navy",
                    "Red",
                    "Sand",
                    "Sport Grey",
                    "White"
                ]
            }
        ],
        "variants": [
            {
                "sku": "HG-18500-BLK-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-4XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - 4XL - Black - Hoodie",
                "size": "4XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-BLK-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-DAR-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-NAY-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - Hoodie - 2XL - Red",
                "size": "2XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - 3XL - Red - Hoodie",
                "size": "3XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - L - Red - Hoodie",
                "size": "L",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - M - Red - Hoodie",
                "size": "M",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - S - Red - Hoodie",
                "size": "S",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-RED-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - XL - Red - Hoodie",
                "size": "XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-4XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - 4XL - Sand - Hoodie",
                "size": "4XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SAD-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-4XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500 - 4XL - Sport Grey - Hoodie",
                "size": "4XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-SPY-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-2XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "2XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-3XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "3XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-L",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-M",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-S",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "HG-18500-WHE-XL",
                "name": "Unisex Heavy Blendâ¢ Hooded Sweatshirt - 18500",
                "size": "XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "HG",
                "style_name": "Hoodie",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "18000",
        "name": "SweatShirt",
        "sku": "18000",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "3XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Ash",
                    "Black",
                    "Dark Heather",
                    "Forest Green",
                    "Military Green",
                    "Navy",
                    "Red",
                    "Sand",
                    "Sport Grey",
                    "White"
                ]
            }
        ],
        "variants": [
            {
                "sku": "SW-18000-ASH-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - 2XL - Ash - SweatShirt",
                "size": "2XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-ASH-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - 3XL - Ash - SweatShirt",
                "size": "3XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-ASH-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - L - Ash - SweatShirt",
                "size": "L",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-ASH-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - M - Ash - SweatShirt",
                "size": "M",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-ASH-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - S - Ash - SweatShirt",
                "size": "S",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-ASH-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - XL - Ash - SweatShirt",
                "size": "XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - SweatShirt - 3XL - Black",
                "size": "3XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-BLK-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-DAR-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-FON-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - M - Military Green - SweatShirt",
                "size": "M",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-MIN-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - XL - Military Green - SweatShirt",
                "size": "XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-NAY-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-RED-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-RED-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-RED-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - M - Red - SweatShirt",
                "size": "M",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-RED-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - S - Red - SweatShirt",
                "size": "S",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-RED-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - L - Sand - SweatShirt",
                "size": "L",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - SweatShirt - M - Sand",
                "size": "M",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SAD-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "3XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-SPY-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-2XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "2XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-3XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000 - 3XL - White - SweatShirt",
                "size": "3XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-L",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-M",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-S",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "SW-18000-WHE-XL",
                "name": "Gildan - Heavy Blendâ¢ Crewneck Sweatshirt - 18000",
                "size": "XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "SW",
                "style_name": "SweatShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "1717",
        "name": "TShirt (1717)",
        "sku": "1717",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "3XL",
                    "4XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Blossom",
                    "Blue Jean",
                    "Chambray",
                    "Crimson",
                    "Denim",
                    "Espresso",
                    "Graphite",
                    "Gray",
                    "Ivory",
                    "Light Green",
                    "Moss",
                    "Mustard",
                    "Navy",
                    "Orchid",
                    "Pepper",
                    "White",
                    "Yam"
                ]
            }
        ],
        "variants": [
            {
                "sku": "UT-1717-BLK-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLK-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 3XL - Black - TShirt",
                "size": "3XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLK-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLK-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLK-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLK-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - 2XL - Blossom",
                "size": "2XL",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - 3XL - Blossom",
                "size": "3XL",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - M - Blossom",
                "size": "M",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - S - Blossom",
                "size": "S",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLM-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Blossom",
                "color_code": "BLM",
                "color_hex": "#F8D1E2",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLN-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Blue Jean",
                "color_code": "BLN",
                "color_hex": "#5B6A7A",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLN-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Blue Jean",
                "color_code": "BLN",
                "color_hex": "#5B6A7A",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLN-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Blue Jean",
                "color_code": "BLN",
                "color_hex": "#5B6A7A",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLN-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Blue Jean",
                "color_code": "BLN",
                "color_hex": "#5B6A7A",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-BLN-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Blue Jean",
                "color_code": "BLN",
                "color_hex": "#5B6A7A",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CBY-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 2XL - Chambray - TShirt",
                "size": "2XL",
                "color": "Chambray",
                "color_code": "CBY",
                "color_hex": "#3da1ff",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CBY-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - L - Chambray - TShirt",
                "size": "L",
                "color": "Chambray",
                "color_code": "CBY",
                "color_hex": "#3da1ff",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CBY-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Chambray - TShirt",
                "size": "M",
                "color": "Chambray",
                "color_code": "CBY",
                "color_hex": "#3da1ff",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CBY-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Chambray - TShirt",
                "size": "S",
                "color": "Chambray",
                "color_code": "CBY",
                "color_hex": "#3da1ff",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CBY-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - XL - Chambray",
                "size": "XL",
                "color": "Chambray",
                "color_code": "CBY",
                "color_hex": "#3da1ff",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CRI-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 2XL - Crimson - TShirt",
                "size": "2XL",
                "color": "Crimson",
                "color_code": "CRI",
                "color_hex": "#ad0000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CRI-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - L - Crimson - TShirt",
                "size": "L",
                "color": "Crimson",
                "color_code": "CRI",
                "color_hex": "#ad0000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CRI-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Crimson - TShirt",
                "size": "M",
                "color": "Crimson",
                "color_code": "CRI",
                "color_hex": "#ad0000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CRI-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Crimson - TShirt",
                "size": "S",
                "color": "Crimson",
                "color_code": "CRI",
                "color_hex": "#ad0000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-CRI-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - XL - Crimson - TShirt",
                "size": "XL",
                "color": "Crimson",
                "color_code": "CRI",
                "color_hex": "#ad0000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 2XL - Denim - TShirt",
                "size": "2XL",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 3XL - Denim - TShirt",
                "size": "3XL",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - L - Denim - TShirt",
                "size": "L",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Denim - TShirt",
                "size": "M",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Denim - TShirt",
                "size": "S",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-DEM-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - XL - Denim - TShirt",
                "size": "XL",
                "color": "Denim",
                "color_code": "DEM",
                "color_hex": "#263a59",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ESO-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 2XL - Espresso - TShirt",
                "size": "2XL",
                "color": "Espresso",
                "color_code": "ESO",
                "color_hex": "#837060",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ESO-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - L - Espresso - TShirt",
                "size": "L",
                "color": "Espresso",
                "color_code": "ESO",
                "color_hex": "#837060",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ESO-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Espresso - TShirt",
                "size": "M",
                "color": "Espresso",
                "color_code": "ESO",
                "color_hex": "#837060",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ESO-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Espresso - TShirt",
                "size": "S",
                "color": "Espresso",
                "color_code": "ESO",
                "color_hex": "#837060",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ESO-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - XL - Espresso - TShirt",
                "size": "XL",
                "color": "Espresso",
                "color_code": "ESO",
                "color_hex": "#837060",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRE-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Graphite",
                "color_code": "GRE",
                "color_hex": "#373231",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRE-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Graphite",
                "color_code": "GRE",
                "color_hex": "#373231",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRE-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - M - Graphite",
                "size": "M",
                "color": "Graphite",
                "color_code": "GRE",
                "color_hex": "#373231",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRE-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Graphite - TShirt",
                "size": "S",
                "color": "Graphite",
                "color_code": "GRE",
                "color_hex": "#373231",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRE-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Graphite",
                "color_code": "GRE",
                "color_hex": "#373231",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 2XL - Gray - TShirt",
                "size": "2XL",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 3XL - Gray - TShirt",
                "size": "3XL",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - L - Gray - TShirt",
                "size": "L",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Gray - TShirt",
                "size": "M",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Gray - TShirt",
                "size": "S",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-GRY-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - XL - Gray - TShirt",
                "size": "XL",
                "color": "Gray",
                "color_code": "GRY",
                "color_hex": "#7d7d7d",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "3XL",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-4XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - 4XL - Ivory - TShirt",
                "size": "4XL",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-IVY-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Ivory",
                "color_code": "IVY",
                "color_hex": "#FFF7E7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-LIN-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Light Green",
                "color_code": "LIN",
                "color_hex": "#738874",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-LIN-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Light Green",
                "color_code": "LIN",
                "color_hex": "#738874",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-LIN-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Light Green - TShirt",
                "size": "M",
                "color": "Light Green",
                "color_code": "LIN",
                "color_hex": "#738874",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-LIN-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Light Green - TShirt",
                "size": "S",
                "color": "Light Green",
                "color_code": "LIN",
                "color_hex": "#738874",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-LIN-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Light Green",
                "color_code": "LIN",
                "color_hex": "#738874",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - 3XL - Moss",
                "size": "3XL",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - M - Moss",
                "size": "M",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MOS-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Moss",
                "color_code": "MOS",
                "color_hex": "#747F66",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MUD-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Mustard",
                "color_code": "MUD",
                "color_hex": "#D0AE6E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-MUD-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Mustard",
                "color_code": "MUD",
                "color_hex": "#D0AE6E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-NAY-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-NAY-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-NAY-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-NAY-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-NAY-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ORD-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Orchid",
                "color_code": "ORD",
                "color_hex": "#CBB3CC",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ORD-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Orchid",
                "color_code": "ORD",
                "color_hex": "#CBB3CC",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ORD-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - M - Orchid - TShirt",
                "size": "M",
                "color": "Orchid",
                "color_code": "ORD",
                "color_hex": "#CBB3CC",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ORD-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Orchid",
                "color_code": "ORD",
                "color_hex": "#CBB3CC",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-ORD-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Orchid",
                "color_code": "ORD",
                "color_hex": "#CBB3CC",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-3XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - TShirt - 3XL - Pepper",
                "size": "3XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-4XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - 4XL - Pepper",
                "size": "4XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - L - Pepper",
                "size": "L",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "S",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-PER-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-WHE-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-WHE-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-WHE-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - M - White",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-WHE-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - T-shirt - S - White",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-WHE-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-YAM-2XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "2XL",
                "color": "Yam",
                "color_code": "YAM",
                "color_hex": "#C9814F",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-YAM-L",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "L",
                "color": "Yam",
                "color_code": "YAM",
                "color_hex": "#C9814F",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-YAM-M",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "M",
                "color": "Yam",
                "color_code": "YAM",
                "color_hex": "#C9814F",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-YAM-S",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717 - S - Yam - TShirt",
                "size": "S",
                "color": "Yam",
                "color_code": "YAM",
                "color_hex": "#C9814F",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-1717-YAM-XL",
                "name": "Comfort Colors - Garment-Dyed Heavyweight T-Shirt - 1717",
                "size": "XL",
                "color": "Yam",
                "color_code": "YAM",
                "color_hex": "#C9814F",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "3001",
        "name": "TShirt (3001)",
        "sku": "3001",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Dark Heather",
                    "Natural",
                    "Pink",
                    "White"
                ]
            }
        ],
        "variants": [
            {
                "sku": "UT-3001-BLK-2XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "2XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-BLK-L",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-BLK-M",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-BLK-S",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-BLK-XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-DAR-2XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "2XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-DAR-L",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "L",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-DAR-M",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "M",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-DAR-S",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "S",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-DAR-XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-NAL-2XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "2XL",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-NAL-L",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "L",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-NAL-M",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "M",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-NAL-S",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "S",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-NAL-XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "XL",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-PIK-2XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001 - 2XL - Pink - TShirt",
                "size": "2XL",
                "color": "Pink",
                "color_code": "PIK",
                "color_hex": "#FFCDCE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-PIK-L",
                "name": "Unisex Jersey Short Sleeve Tee - 3001 - L - Pink - TShirt",
                "size": "L",
                "color": "Pink",
                "color_code": "PIK",
                "color_hex": "#FFCDCE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-PIK-M",
                "name": "Unisex Jersey Short Sleeve Tee - 3001 - M - Pink - TShirt",
                "size": "M",
                "color": "Pink",
                "color_code": "PIK",
                "color_hex": "#FFCDCE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-PIK-S",
                "name": "Unisex Jersey Short Sleeve Tee - 3001 - S - Pink - TShirt",
                "size": "S",
                "color": "Pink",
                "color_code": "PIK",
                "color_hex": "#FFCDCE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-PIK-XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001 - XL - Pink - TShirt",
                "size": "XL",
                "color": "Pink",
                "color_code": "PIK",
                "color_hex": "#FFCDCE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-WHE-2XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "2XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-WHE-L",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-WHE-M",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-WHE-S",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-3001-WHE-XL",
                "name": "Unisex Jersey Short Sleeve Tee - 3001",
                "size": "XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "5000",
        "name": "TShirt (5000)",
        "sku": "5000",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "2XL",
                    "3XL",
                    "4XL",
                    "5XL",
                    "L",
                    "M",
                    "S",
                    "XL"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Ash",
                    "Black",
                    "Charcoal",
                    "Daisy",
                    "Dark Chocolate",
                    "Dark Heather",
                    "Forest Green",
                    "Heliconia",
                    "Light Blue",
                    "Light Pink",
                    "Maroon",
                    "Military Green",
                    "Natural",
                    "Navy",
                    "Orange",
                    "Pepper",
                    "Purple",
                    "Red",
                    "Royal",
                    "Sand",
                    "Sport Grey",
                    "Tennessee Orange",
                    "White"
                ]
            }
        ],
        "variants": [
            {
                "sku": "UT-5000-ASH-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 2XL - Ash - TShirt",
                "size": "2XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ASH-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ASH-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ASH-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ASH-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ASH-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Ash",
                "color_code": "ASH",
                "color_hex": "#F6F6F6",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-4XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - TShirt - 4XL - Black",
                "size": "4XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-5XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - TShirt - 5XL - Black",
                "size": "5XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-BLK-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 2XL - Charcoal - TShirt",
                "size": "2XL",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-CHL-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Charcoal - TShirt",
                "size": "XL",
                "color": "Charcoal",
                "color_code": "CHL",
                "color_hex": "#585559",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Dark Chocolate",
                "color_code": "DAE",
                "color_hex": "#31221D",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAR-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - L - Daisy - TShirt",
                "size": "L",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-DAY-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Daisy - TShirt",
                "size": "XL",
                "color": "Daisy",
                "color_code": "DAY",
                "color_hex": "#2A2930",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-FON-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Forest Green - TShirt",
                "size": "XL",
                "color": "Forest Green",
                "color_code": "FON",
                "color_hex": "#223B26",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-HEA-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Heliconia",
                "color_code": "HEA",
                "color_hex": "#DF5086",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - TShirt - 2XL - Light Blue",
                "size": "2XL",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-LIK-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 2XL - Maroon - TShirt",
                "size": "2XL",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MAN-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Maroon",
                "color_code": "MAN",
                "color_hex": "#642838",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - TShirt - 2XL - Military Green",
                "size": "2XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-MIN-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - TShirt - XL - Military Green",
                "size": "XL",
                "color": "Military Green",
                "color_code": "MIN",
                "color_hex": "#62664C",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAL-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - XL - Natural",
                "size": "XL",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-NAY-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Navy",
                "color_code": "NAY",
                "color_hex": "#1A2237",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ORE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Orange",
                "color_code": "ORE",
                "color_hex": "#EA5F22",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PER-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - 2XL - Pepper",
                "size": "2XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PER-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - L - Pepper",
                "size": "L",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PER-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - M - Pepper",
                "size": "M",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PER-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - S - Pepper",
                "size": "S",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PER-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - XL - Pepper",
                "size": "XL",
                "color": "Pepper",
                "color_code": "PER",
                "color_hex": "#5F605B",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-PUE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Purple",
                "color_code": "PUE",
                "color_hex": "#3C214E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-4XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 4XL - Red - TShirt",
                "size": "4XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-RED-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Red - TShirt",
                "size": "XL",
                "color": "Red",
                "color_code": "RED",
                "color_hex": "#C62A32",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 2XL - Royal - TShirt",
                "size": "2XL",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-ROL-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Royal - TShirt",
                "size": "XL",
                "color": "Royal",
                "color_code": "ROL",
                "color_hex": "#084F97",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 2XL - Sand - TShirt",
                "size": "2XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SAD-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - XL - Sand - TShirt",
                "size": "XL",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-SPY-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "2XL",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "L",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "M",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "S",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-TEE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "XL",
                "color": "Tennessee Orange",
                "color_code": "TEE",
                "color_hex": "#F79B2E",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-2XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - 2XL - White",
                "size": "2XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-3XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000",
                "size": "3XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-4XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 4XL - White - TShirt",
                "size": "4XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-5XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - 5XL - White - TShirt",
                "size": "5XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-L",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - L - White",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-M",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - M - White",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-S",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - S - White",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "UT-5000-WHE-XL",
                "name": "Gildan - Heavy Cottonâ¢ T-Shirt - 5000 - T-shirt - XL - White",
                "size": "XL",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "UT",
                "style_name": "TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    },
    {
        "id": "5000B",
        "name": "Youth TShirt",
        "sku": "5000B",
        "thumbnail": null,
        "options": [
            {
                "option": "size",
                "values": [
                    "L",
                    "M",
                    "S"
                ]
            },
            {
                "option": "color",
                "values": [
                    "Black",
                    "Dark Heather",
                    "Light Blue",
                    "Light Pink",
                    "Natural",
                    "Sand",
                    "Sport Grey",
                    "White"
                ]
            }
        ],
        "variants": [
            {
                "sku": "YT-5000B-BLK-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "L",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-BLK-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "M",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-BLK-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "S",
                "color": "Black",
                "color_code": "BLK",
                "color_hex": "#000000",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-DAR-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "L",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-DAR-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "M",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-DAR-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "S",
                "color": "Dark Heather",
                "color_code": "DAR",
                "color_hex": "#454545",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIE-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - L - Light Blue - Youth TShirt",
                "size": "L",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIE-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - M - Light Blue - Youth TShirt",
                "size": "M",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIE-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - S - Light Blue - Youth TShirt",
                "size": "S",
                "color": "Light Blue",
                "color_code": "LIE",
                "color_hex": "#D6E6F7",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIK-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - L - Light Pink - Youth TShirt",
                "size": "L",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIK-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - M - Light Pink - Youth TShirt",
                "size": "M",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-LIK-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - S - Light Pink - Youth TShirt",
                "size": "S",
                "color": "Light Pink",
                "color_code": "LIK",
                "color_hex": "#FEE0EB",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-NAL-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - L - Natural - Youth TShirt",
                "size": "L",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-NAL-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - M - Natural - Youth TShirt",
                "size": "M",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-NAL-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B - S - Natural - Youth TShirt",
                "size": "S",
                "color": "Natural",
                "color_code": "NAL",
                "color_hex": "#FFF8EA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SAD-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "L",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SAD-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "M",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SAD-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "S",
                "color": "Sand",
                "color_code": "SAD",
                "color_hex": "#DCD2BE",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SPY-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "L",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SPY-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "M",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-SPY-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "S",
                "color": "Sport Grey",
                "color_code": "SPY",
                "color_hex": "#CACACA",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-WHE-L",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "L",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-WHE-M",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "M",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            },
            {
                "sku": "YT-5000B-WHE-S",
                "name": "Gildan - Heavy Cottonâ¢ Youth T-Shirt - 5000B",
                "size": "S",
                "color": "White",
                "color_code": "WHE",
                "color_hex": "#FFFFFF",
                "style": "YT",
                "style_name": "Youth TShirt",
                "image": null,
                "status": "available",
                "service_codes": [
                    "DTG"
                ]
            }
        ]
    }
];

export default anprint;
